import { render, staticRenderFns } from "./btnsCom.vue?vue&type=template&id=37b5dc7b"
import script from "./btnsCom.vue?vue&type=script&lang=js"
export * from "./btnsCom.vue?vue&type=script&lang=js"
import style0 from "./btnsCom.vue?vue&type=style&index=0&id=37b5dc7b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/crm-admin-uat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b5dc7b')) {
      api.createRecord('37b5dc7b', component.options)
    } else {
      api.reload('37b5dc7b', component.options)
    }
    module.hot.accept("./btnsCom.vue?vue&type=template&id=37b5dc7b", function () {
      api.rerender('37b5dc7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CustomerDrawerCom/leftTopCom/btnsCom.vue"
export default component.exports